import React from "react";
import { showToast } from "../../../../../Helper/Toast";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { hitGetSettingsApi } from "../../../../../Redux/Common/GetSettingsSlice";

const PrivacyPolicy = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [text, setText] = React.useState("");

  useEffect(() => {
    if (!localStorage.getItem("professionalToken")) {
      navigate("/professional/login");
    } else {
      dispatch(hitGetSettingsApi()).then((response) => {
        if (response.payload && response.payload.status === true) {
          setText(response.payload.data.privacyPolicyText);
          // Handle the settings data if needed
        }
      });
    }
  }, [dispatch, navigate]);

  return (
      <div className="delete-account-container">
        <div
          className="warning-card"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </div>
  );
};

export default PrivacyPolicy;
